import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./app";

// Post-login redirect logic
const postLoginRedirect = localStorage.getItem("postLoginRedirect");
if (postLoginRedirect && window.location.pathname === "/") {
  localStorage.removeItem("postLoginRedirect");
  window.location.replace(postLoginRedirect);
}

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
